import React from 'react'

export default ({ ...props }) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0)'>
      <path
        d='M13.1439 3.5588L11.0439 2.1588C10.9865 2.1203 10.9186 2.1 10.85 2.1H7.7V1.05C7.7 0.4711 7.2289 0 6.65 0H5.25C4.6711 0 4.2 0.4711 4.2 1.05V2.1H0.35C0.1568 2.1 0 2.2568 0 2.45V5.25C0 5.4432 0.1568 5.6 0.35 5.6H4.2V6.3H3.15C3.0807 6.3 3.0135 6.3203 2.9561 6.3588L0.8561 7.7588C0.7588 7.8239 0.7 7.9331 0.7 8.05C0.7 8.1669 0.7588 8.2761 0.8561 8.3412L2.9561 9.7412C3.0135 9.7797 3.0814 9.8 3.15 9.8H4.2V13.65C4.2 13.8432 4.3568 14 4.55 14H7.35C7.5432 14 7.7 13.8432 7.7 13.65V9.8H10.15C10.3432 9.8 10.5 9.6432 10.5 9.45V6.65C10.5 6.4568 10.3432 6.3 10.15 6.3H7.7V5.6H10.85C10.9193 5.6 10.9865 5.5797 11.0439 5.5412L13.1439 4.1412C13.2412 4.0761 13.3 3.9669 13.3 3.85C13.3 3.7331 13.2412 3.6239 13.1439 3.5588ZM4.9 1.05C4.9 0.8568 5.0568 0.7 5.25 0.7H6.65C6.8432 0.7 7 0.8568 7 1.05V2.1H4.9V1.05ZM7 13.3H4.9V9.8H7V13.3ZM9.8 9.1H3.2557L1.6807 8.05L3.2557 7H9.8V9.1ZM7 6.3H4.9V5.6H7V6.3ZM10.7443 4.9H0.7V2.8H10.7443L12.3193 3.85L10.7443 4.9Z'
        fill='#0D0D0D'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
